import React, { useEffect } from "react";
import { useFieldArray, useWatch } from "react-hook-form";
import Input from "../Input/Input";
import styles from "./AcademicLinks.module.css";

const AcademicLinks = ({ register, control, errors, disabled }) => {
  const { fields, append, remove } = useFieldArray({
    control,
    name: "academicLinks",
  });

  // Watch all Academic links
  const academicLinks = useWatch({
    control,
    name: "academicLinks",
    defaultValue: [],
  });

  // Ensure at least one field exists
  useEffect(() => {
    if (fields.length === 0) {
      append("");
    }
  }, [fields, append]);

  return (
    <div className={styles.grid}>
      {fields.map((item, idx) => {
        const isLast = idx === fields.length - 1;
        const currentValue = academicLinks?.[idx];
        const isDisabled = !currentValue?.trim();

        return (
          <div key={item.id} className={styles.colum}>
            {!disabled && isLast && (
              <button
                type="button"
                className={styles.add}
                disabled={isDisabled}
                onClick={() => append("")}
              >
                +
              </button>
            )}

            <Input
              label={
                idx > 0
                  ? `Academic Profile Link ${idx + 1}`
                  : "Academic Profile Link"
              }
              name={`academicLinks.${idx}`}
              register={register}
              errors={errors}
              validation={{
                required: "Academic profile link is required",
                pattern: {
                  value: /^(https?:\/\/)(www\.)?.+/i,
                  message: "Enter a valid URL",
                },
              }}
              disabled={disabled}
            />
            {!disabled && isDisabled && (
              <span className={styles.tooltip}>
                Please fill the current academic profile link to add more
              </span>
            )}
            {idx > 0 && (
              <button
                type="button"
                className={styles.remove}
                onClick={() => remove(idx)}
              >
                X
              </button>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default AcademicLinks;
